const breakpoints = {
    xs: 575,
    sm: 767,
    md: 991,
    lg: 1199,
    xl: Infinity // sempre visível
}

/**
 * Retorna 'none' se a tela for menor ou igual ao breakpoint fornecido
 * @param {'xs'|'sm'|'md'|'lg'|'xl'} bp
 * @returns {'none' | ''} valor para style.display
 */
export function biggerThan(bp) {
    if (typeof window === 'undefined') return '' // SSR safety

    const max = breakpoints[bp] ?? 0
    return window.innerWidth <= max ? 'none' : ''
}
